/**
 * Created by andrey on 23.07.2025
 */

/**
 * Represents an interface for metrics-related functionalities.
 * Provides methods to retrieve metrics, log events, and handle event-based interactions.
 *
 * @namespace Metrics
 */
const MetricsInterface = function () {
    return {
        /**
         * @memberof Metrics
         * @desc Calculates the number of days that have passed since the user's registration. If the `timestamp` parameter is not provided, the current date and time (Date.now()) is used.
         * @param {number} [timestamp=Date.now()] - The optional timestamp to calculate the difference from the registration time.
         * @returns {number} The number of days since registration.
         */
        getDaysSinceRegistration: function (timestamp) {
            return connector._metrics.getDaysSinceRegistration(timestamp);
        },

        /**
         * @memberof Metrics
         * @desc Sets the user acquisition channel
         * @param {Object} channel - The channel object to be set, which will be used for logging events
         */
        setChannel: function (channel) {
            connector._metrics.setChannel(channel);
        },

        /**
         * @memberof Metrics
         * @desc Logs an event with the specified name and parameters.
         *
         * Reserved parameter names — DO NOT use these keys inside `params`, they are
         * controlled by the connector/server and will be ignored if passed:
         *   - `source` — traffic source / network (e.g. `android`, `ios`, `vk`),
         *                set automatically from `connector.info.source`.
         *
         * @function
         * @param {string} name - The name of the event to be logged.
         * @param {Object} params - An object containing parameters associated with the event.
         */
        logEvent: function (name, params = {}) {
            connector._metrics.logEvent(name, params);
        },

        /**
         * @memberof Metrics
         * @desc Attaches a listener for the specified event and executes the callback function when the event is triggered.
         * @param {string} eventName - The name of the event to listen for.
         * @param {Function} callback - The callback function to execute when the event is triggered.
         */
        on: function (eventName, callback) {
            connector._metrics.on(eventName, callback);
        }
    };
};